<app-navbar-style-one></app-navbar-style-one>

<div class="inner-banner inner-bg1">
    <div class="container">
        <div class="inner-title text-center">
            <h3>{{subCategoryName | titlecase}}</h3>
        </div>
    </div>
</div>

<div class="mt-5"> <!--  class="inner-banner inner-bg3" -->
    
    <div class="alert alert-success" *ngIf="showSuccess" style="position: fixed;top: 20%;direction: ltr;left: 50%;transform: translate(-50%, -50%);z-index: 99999999999999;"> <!--*ngIf="showError" -->
        {{successMsg}}
    </div>
    <div class="alert alert-danger" *ngIf="showError" style="position: fixed;top: 20%;direction: ltr;left: 50%;transform: translate(-50%, -50%);z-index: 99999999999999;"> <!--*ngIf="showError" -->
        {{errorMsg}}
    </div>
    <div class="container-fluid">
        <div class="inner-banner-title text-center" style="position: relative;">

           

            <img class="categoryImage" src="{{categoryImage}}" alt="{{categoryImage}}">
            <!-- <h3 class="subCategoryName">{{subCategoryName | titlecase}}</h3> -->
            <!-- <p dir="ltr" *ngIf="vendorInfo">
                <i *ngFor="let star of [].constructor(vendorInfo.rate); let j = index" class="fa-solid fa-star"></i>
                <i *ngFor="let emptyStar of [].constructor(5 - vendorInfo.rate); let k = index" class="fa-regular fa-star icon-color"></i>
            </p> -->
            <!-- <div class="">
                <div class="city-card text-center mb-0">
                    <div class="content m-auto">
                        <div class="vendorInfo-div" *ngIf="vendorInfo">
                            <p style="border-right: 3px solid #000;padding-right: 20px;" class="mb-0">
                                <i class="fa-solid fa-clock"></i> {{vendorInfo.delivery_time}} دقيقة
                            </p>
                            <p style="padding-left: 20px;" class="mb-0">
                                <i class="fa-solid fa-motorcycle"></i> {{vendorInfo.delivery_cost}} جنية
                            </p>
                            <p style="padding-left: 20px;border-left: 3px solid #000;" class="mb-0">
                                <i class="fa-solid fa-motorcycle"></i> {{vendorInfo.delivery_cost}} جنية
                            </p>
                        </div>
                    </div>
                </div>
            </div> -->

            <div class="">
                <div class="city-card text-center mb-0">
                    <div class="content m-auto py-2 px-0" style="background-color: transparent !important;box-shadow: none !important;">
                        <div class="vendorInfo-div" >
                            <!-- <p style="border-right: 3px solid #000;padding-right: 10px;" class="mb-0">
                                {{vendorInfo?.delivery_time}} دقيقة <img src="assets/img/clock-color-icon.png" width="25px" alt="clock">
                            </p>
                            <p style="padding-left: 10px;padding-right: 10px;" class="mb-0">
                                {{vendorInfo?.delivery_cost}} جنية <img src="assets/img/food-delivery.png" width="25px" alt="clock">
                            </p> -->
                            <p style="border-right: 3px solid #000;padding-right: 10px;    direction: rtl;" class="mb-0">
                                <img src="assets/img/clock-color-icon.png" width="25px" alt="clock"> {{selectedVendor?.deliveryTime}}
                            </p>
                            <p style="padding-left: 10px;padding-right: 10px;    direction: rtl;" class="mb-0">
                                <img src="assets/img/food-delivery.png" width="25px" alt="clock"> {{selectedVendor?.deliveryCost}}
                            </p>
                            <p style="padding-left: 10px;border-left: 3px solid #000;" class="mb-0">
                                
                                <span class="restaurantStatus openRestaurant" *ngIf="currentStatus === 'مفتوح'">
                                    {{currentStatus}}
                                </span>
                                <span class="restaurantStatus busyRestaurant" *ngIf="currentStatus === 'مشغول'">
                                    {{currentStatus}}
                                </span>
                                <span class="restaurantStatus closedRestaurant" *ngIf="currentStatus === 'مغلق'">
                                    {{currentStatus}}
                                </span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <!-- <div class="banner-list">
            <div class="row align-items-center">
                <div class="form-floating mb-3">
                    <input type="text" class="form-control" id="floatingInput" (input)="searchProducts($event.target.value)" placeholder="ماذا تريد أن تطلب اليوم؟">
                    <label for="floatingInput">ماذا تريد أن تطلب اليوم؟</label>
                </div>
            </div>
        </div> -->
        <div class="banner-list mb-1">
            <div class="row align-items-center">
              <div class="form-floating position-relative">
                <input type="text" class="form-control" id="floatingInput" 
                       (input)="searchProducts($event.target.value)" 
                       placeholder="ماذا تريد أن تطلب اليوم؟"
                       (focus)="showResults = true"
                       (blur)="onSearchBlur()">
                <label for="floatingInput">ماذا تريد أن تطلب اليوم؟</label>
                
                <!-- Search results dropdown -->
                <div class="search-results-dropdown" *ngIf="showResults && searchedProducts && searchedProducts.length > 0">
                  <div class="list-group">
                    <a *ngFor="let product of searchedProducts" 
                       class="list-group-item list-group-item-action"
                       (click)="selectProduct(product)"
                       (mousedown)="preventBlur($event)">
                       <img src="https://admin.waslaapp.com/storage/images/products/{{product.avatar}}" width="80" alt="{{product.name}}">
                      {{product.name_en}} - {{product.name_ar}}
                      <span *ngIf="product.offer" class="badge bg-success ms-2">
                        {{product.offer_value}}% OFF
                      </span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
    </div>
</div>

<div class="listing-widget-section pt-2 pb-70">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="listing-widget-into">

                    <!-- <div class="row">
                        <div class="col-lg-4 col-md-4" *ngFor="let sub of subCategories;let i = index">
                            <div class="place-list-item">
                                <div class="images">
                                    <a href="listing/{{sub.hashedId}}/{{sub.name}}" (click)="sendImage(sub.avatar)" class="images-list"><img src="{{sub.avatar}}" alt="{{sub.name}}"></a>
                                </div>
        
                                <div class="content">
                                    <a href="listing/{{sub.hashedId}}/{{sub.name}}" (click)="sendImage(sub.avatar)"><h3> {{sub.name}}</h3></a>                                     
                                </div>
                            </div>                
                        </div>

                        <div class="col-lg-12 text-center" *ngIf="subCategoriesLength == 10"> 
                            <a routerLink="/listing" class="default-btn border-radius">المزيد <i class='bx bx-plus'></i></a>
                        </div>
                    </div> -->
                </div>
            </div>
        </div>
    </div>

    <div class="alert alert-danger" *ngIf="subCategoriesLength == 0">
        لم يتم العثور على فئات
    </div>
    <div style="width: 100%; overflow-x: auto;scrollbar-color: #fff #bada55;">
        <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist" style="white-space: nowrap; display: inline-block;">
            <li class="nav-item" role="presentation" *ngFor="let sub of subCategories;let i = index" style="display: inline-block; float: none;">
            <button 
                class="nav-link" 
                [ngClass]="{'active': i === 0}" 
                id="pills-tab-{{i}}" 
                data-bs-toggle="pill" 
                [attr.data-bs-target]="'#pills-content-'+i" 
                type="button" 
                role="tab" 
                [attr.aria-controls]="'pills-content-' + i" 
                [attr.aria-selected]="i === 0 ? 'true' : 'false'"
                (click)="getProducts(sub.id)">
                <img class="image-btn m-auto" src="{{sub.avatar}}" alt="{{sub.name}}">
                {{ sub.name }}
            </button>
            </li>
        </ul>
    </div>
    <!-- <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist" style="width: 100000px;overflow-x: scroll;">
        <li class="nav-item" role="presentation" *ngFor="let sub of subCategories;let i = index">
            <button 
            class="nav-link" 
            [ngClass]="{'active': i === 0}" 
            id="pills-tab-{{i}}" 
            data-bs-toggle="pill" 
            [attr.data-bs-target]="'#pills-content-'+i" 
            type="button" 
            role="tab" 
            [attr.aria-controls]="'pills-content-' + i" 
            [attr.aria-selected]="i === 0 ? 'true' : 'false'"
            (click)="getProducts(sub.id)">
                <img class="image-btn" src="{{sub.avatar}}" alt="{{sub.name}}">
                {{ sub.name }}
            </button>
        </li>
    </ul> -->
    <div class="tab-content mb-5" id="pills-tabContent">
        <div 
        *ngFor="let product of products; let i = index"
        class="tab-pane fade" 
        [ngClass]="{'show active': i === 0}"
        id="pills-content-{{i}}" 
        role="tabpanel" 
        [attr.aria-labelledby]="'pills-tab-' + i">
            <div class="row">
                <div class="col-lg-4 col-12 text-center" *ngFor="let product of products; let i = index">
                    <div class="row product-list-item">
                        <div class="col-4">
                            <img src="{{product.avatar}}" alt="{{product.name}}" style="cursor: pointer;" (click)="productPage(subCategoryName,product.name,product.id)" width="80" srcset="">
                        </div>
                        <div class="col-4">
                            <h5 style="cursor: pointer;" (click)="productPage(subCategoryName,product.name,product.id)">{{product.name}}</h5>
                            <span class="sizes" [ngClass]="{'active': selectedSizes[product.id]?.id === type.id}" *ngFor="let type of product.types; let j = index">
                                <input 
                                type="radio" 
                                [value]="type" 
                                name="size-{{product.id}}" 
                                [(ngModel)]="selectedSizes[product.id]"
                                [id]="type.abbrev+'-'+product.id"
                                hidden>
                                <label for="{{type.abbrev}}-{{product.id}}">{{ type.abbrev }}</label>
                            </span>
                        </div>
                        <div class="col-4 oneRowPrice" style="position: relative;">
                            <img class="discount-image" *ngIf="product.offer != null" src="../../../../assets/img/discount.png" alt="Discount image">
                            <span style="color: #000 !important;margin-bottom: 7px;" class="" dir="ltr"><strong>{{ selectedSizes[product.id]?.price || product.types[0].price }}</strong> EGP</span>
                            <span class="plusBtn " *ngIf="!productQuantities[product.id] || productQuantities[product.id] === 0" 
                            (click)="quantity(product.id, 1)">+</span>
        
                            <div class="number " *ngIf="productQuantities[product.id] && productQuantities[product.id] >= 1">
                                <span class="minus" (click)="quantity(product.id, -1)">-</span>
                                <input type="text" id="quantity{{product.id}}" [value]="productQuantities[product.id]" readonly/>
                                <span class="plus" (click)="quantity(product.id, 1)">+</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div class="row product-list-item" *ngFor="let product of products; let i = index">
                <div class="col-4">
                    <img src="{{product.avatar}}" alt="product.name" width="80" srcset="">
                </div>
                <div class="col-4">
                    <h5>{{product.name}}</h5>
                    <span class="sizes" [ngClass]="{'active': selectedSizes[product.id]?.id === type.id}" *ngFor="let type of product.types; let j = index">
                        <input 
                        type="radio" 
                        [value]="type" 
                        name="size-{{product.id}}" 
                        [(ngModel)]="selectedSizes[product.id]"
                        [id]="type.abbrev+'-'+product.id"
                        hidden>
                        <label for="{{type.abbrev}}-{{product.id}}">{{ type.abbrev }}</label>
                    </span>
                </div>
                <div class="col-4" style="position: relative;">
                    <img class="discount-image" *ngIf="product.offer != null" src="../../../../assets/img/discount.png" alt="Discount image">
                    <p class="text-start" dir="ltr"><strong>{{ selectedSizes[product.id]?.price || product.types[0].price }}</strong> EGP</p>
                    <span class="plusBtn" *ngIf="!productQuantities[product.id] || productQuantities[product.id] === 0" 
                    (click)="quantity(product.id, 1)">+</span>

                    <div class="number" *ngIf="productQuantities[product.id] && productQuantities[product.id] >= 1">
                        <span class="minus" (click)="quantity(product.id, -1)">-</span>
                        <input type="text" id="quantity{{product.id}}" [value]="productQuantities[product.id]" readonly/>
                        <span class="plus" (click)="quantity(product.id, 1)">+</span>
                    </div>
                </div>
            </div> -->
            <div class="row mt-3 mb-4" *ngIf="getTotalAddedQuantity() > 0">
                <div class="col-12 px-5" style="position: fixed;bottom: 0;background: #fff;padding-bottom: 12px;">
                    <button class="btn btn-custom" (click)="sendCart()" [disabled]="currentStatus != 'مفتوح'">
                        <span style="position: relative;">
                            <i class="fa fa-cart-shopping"></i>
                            <span class="cart-number">{{ getTotalAddedQuantity() }}</span>
                        </span> إضافة الي السلة
                    </button>
                </div>
            </div>
        </div>


        <!-- Button trigger modal -->
        <button type="button" id="openModal" class="btn btn-primary d-none" data-bs-toggle="modal" data-bs-target="#staticBackdrop"></button>
        
        <!-- Modal -->
        <div class="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="staticBackdropLabel">تسجيل الدخول</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body text-center">
                        <i class="fa-solid fa-triangle-exclamation"></i>
                        <p class="signInFirst">
                            برجاء تسجيل الدخول اولا
                        </p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">الغاء</button>
                        <a href="login-register" type="button" class="btn btn-primary">تسجيل الدخول</a>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div class="alert alert-danger" *ngIf="signInFirst">
        </div> -->
        <div class="alert alert-danger" *ngIf="productLength == 0">
            لم يتم العثور على أي منتجات في هذه الفئة
        </div>
    </div>
</div>

<!-- <app-footer-style-two></app-footer-style-two> -->